'use es6';

import { List } from 'immutable';
import map from 'transmute/map';
import pipe from 'transmute/pipe';
import { Component, forwardRef } from 'react';
import ReferenceInputEnumAll from './enum/ReferenceInputEnumAll';
import ReferenceInputEnumNone from './enum/ReferenceInputEnumNone';
import ReferenceInputEnumSearch from './enum/ReferenceInputEnumSearch';
import { syntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';
import toJS from 'transmute/toJS';
import translate from 'transmute/translate';
import omit from 'transmute/omit';
import { propertyDescriptionTranslator, propertyLabelTranslator } from 'property-translator/propertyTranslator';
import { defaultFilterOption } from './defaults/defaultFilterOption';
import { jsx as _jsx } from "react/jsx-runtime";
export const toSelectOptions = pipe(map(translate({
  help: property => property.hubspotDefined ? propertyDescriptionTranslator(property.label, property.description) : property.description,
  icon: true,
  text: property => property.hubspotDefined ? propertyLabelTranslator(property.label) : property.label,
  value: true,
  disabled: true
})), toJS);
const defaultProps = {
  options: []
};
export class ReferenceInputEnum extends Component {
  constructor(...args) {
    super(...args);
    this.handleChange = evt => {
      const {
        multi,
        onChange
      } = this.props;
      if (multi) {
        onChange(syntheticEvent(List(evt.target.value)));
        return;
      }
      onChange(evt);
    };
  }
  getOptions() {
    const {
      options
    } = this.props;
    if (!options || Array.isArray(options)) {
      return options;
    }
    return toSelectOptions(options);
  }
  getReferenceEnumComponent() {
    const {
      resolver
    } = this.props;
    if (!resolver) {
      return ReferenceInputEnumNone;
    }
    if (resolver.search) {
      return ReferenceInputEnumSearch;
    }
    return ReferenceInputEnumAll;
  }
  getValue() {
    const {
      multi,
      value
    } = this.props;
    if (multi) {
      return value ? value.toArray() : [];
    }
    return value;
  }
  render() {
    const ReferenceEnum = this.getReferenceEnumComponent();
    const transferableProps = omit(['getProperty', 'objectType', 'showError', 'showPlaceholder', 'subjectId', 'secondaryChanges', 'onSecondaryChange', 'onChangeMultiple', 'innerRef'], this.props);
    return /*#__PURE__*/_jsx(ReferenceEnum, Object.assign({}, transferableProps, {
      anchorType: "button",
      filterOption: defaultFilterOption,
      inputRef: this.props.inputRef,
      onChange: this.handleChange,
      options: this.getOptions(),
      ref: this.props.innerRef,
      value: this.getValue()
    }));
  }
}
ReferenceInputEnum.defaultProps = defaultProps;
export default /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/_jsx(ReferenceInputEnum, Object.assign({}, props, {
  innerRef: ref
})));